export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [4,[2]],
		"/(app)/camera": [5,[2]],
		"/(app)/handovers": [6,[2]],
		"/login": [20],
		"/(app)/not-found": [7,[2]],
		"/(app)/returns": [8,[2]],
		"/(app)/task/[type]/[uid]/checklist": [9,[2,3]],
		"/(app)/task/[type]/[uid]/contract": [10,[2,3]],
		"/(app)/task/[type]/[uid]/damages": [11,[2,3]],
		"/(app)/task/[type]/[uid]/damages/new": [13,[2,3]],
		"/(app)/task/[type]/[uid]/damages/[damage]": [12,[2,3]],
		"/(app)/task/[type]/[uid]/extras/new": [14,[2,3]],
		"/(app)/task/[type]/[uid]/finish": [15,[2,3]],
		"/(app)/task/[type]/[uid]/finish/[signature]": [16,[2,3]],
		"/(app)/task/[type]/[uid]/payment": [17,[2,3]],
		"/(app)/task/[type]/[uid]/payment/new": [18,[2,3]],
		"/(app)/task/[type]/[uid]/photos": [19,[2,3]],
		"/upgrade": [21]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';